import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { Header } from '../components/sections'
import Footer from '../components/footer'
import '../styles/main.scss'

const propTypes = {
  children: PropTypes.func,
}

const NAV_ITEMS = [
  { displayName: 'Home', url: '/' },
  { displayName: 'About', url: '/about' },
  { displayName: 'Services', url: '/services' },
  { displayName: 'Contact', url: '/contact' },
]

class Layout extends Component {
  render() {
    const { children, data, location } = this.props
    const { pathname } = location
    const currentPath = pathname === '/' ? '/front-page' : pathname
    const bodyClass = currentPath.substring(1)
    return (
      <div className="site-content">
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            {
              name: 'description',
              content:
                'Offering professional window and gutter cleaning services across Basingstoke & surrounding areas',
            },
            {
              name: 'keywords',
              content:
                'window, cleaning, gutter, roof, basingstoke, clear h2o, matthew skinner, jake brown',
            },
          ]}
          bodyAttributes={{ class: `site-body site-body--${bodyClass}` }}
        />
        <Header navItems={NAV_ITEMS} />
        {children()}
        <Footer navItems={NAV_ITEMS} />
      </div>
    )
  }
}

Layout.propTypes = propTypes

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js